import { Capacitor, CapacitorHttp } from '@capacitor/core'

const isNative = Capacitor.isNativePlatform()
const APP_BASE_URL = process.env.BUN_PUBLIC_APP_BASE_URL ?? ''

type DirectusResponse<T> = { data: T }

function toUrl(path: string) {
  return isNative ? `${APP_BASE_URL}${path}` : path
}

export async function directusRequest<T>(
  path: string,
  method: string = 'GET',
  body?: object,
): Promise<T> {
  if (isNative) {
    const response = await CapacitorHttp.request({
      url: toUrl(path),
      method,
      headers: { 'Content-Type': 'application/json' },
      ...(body ? { data: body } : {}),
    })
    if (response.status >= 400) {
      throw new Error(`Directus request failed: ${response.status}`)
    }
    return (response.data as DirectusResponse<T>).data
  }

  const response = await fetch(toUrl(path), {
    method,
    headers: { 'Content-Type': 'application/json' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  })
  if (!response.ok) {
    throw new Error(`Directus request failed: ${response.status}`)
  }
  return ((await response.json()) as DirectusResponse<T>).data
}

export async function directusUpload<T>(
  path: string,
  formData: FormData,
): Promise<T> {
  // CapacitorHttp can't send FormData, so uploads always go through fetch
  const response = await fetch(toUrl(path), { method: 'POST', body: formData })
  if (!response.ok) {
    throw new Error(`Directus upload failed: ${response.status}`)
  }
  return ((await response.json()) as DirectusResponse<T>).data
}
